import Swal from 'sweetalert2';
import requestApi from 'utils/Request';
import { OPERATION_LOG } from 'utils/StaticApiEndpoints';
import {
  failureOperationLogList,
  requestOperationLogList,
  responseOperationLogList,
} from '../../slices/operationLogSlice/operationLogSlice';

/** RAT-1760 AC-6: filtered, scoped list of every logged data change. */
export const ListOperationLogData = (payload) => async (dispatch) => {
  try {
    dispatch(requestOperationLogList());
    const res = await requestApi.get(OPERATION_LOG, { params: payload });
    dispatch(responseOperationLogList(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureOperationLogList(error?.message));
  }
};
